import React from "react";
import { ConsumerPlansPage } from "../features/";

export default ConsumerPlansPage;
